<template>
  <v-row id="paymentManager">
    <div class="container">
      <v-row>
          <v-col cols="12" md="12">
              <h1 class="text-left mb-0" style="color:black;"> {{$tc("payment_manager.title")}}</h1>
              <p class="text-left mb-0">{{ $tc("payment_manager.description") }}</p>
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="text-left">
          <v-btn color="primary" @click="dialog = true">
            {{$tc("payment_manager.add_payment_method")}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="-1"
            class="elevation-1"
            :footer-props="{
              'items-per-page-text': $t('dataTable.rowsPerPageText'),
              'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
            }"
            :no-data-text="$t('dataTable.noDataText')"
            :headerProps="{
              'sort-by-text': $t('dataTable.sortByText')
            }"
          >
          <template v-slot:item.isActive="{ item }">
            {{ item.isActive ?  $tc("payment_manager.opt_yes") : $tc("payment_manager.opt_no") }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn icon @click="editItem(item)" class="mr-2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <i class="fas fa-pencil-alt fa-lg" v-on="on"></i>
                </template>
                <span>{{ $tc("payment_manager.btn_edit") }}</span>
              </v-tooltip>
            </v-btn>

            <v-btn icon @click="deleteItem(item)" class="mr-2" v-if="item.isActive">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <i class="fas fa-check-circle fa-lg" v-on="on"></i>
                </template>
                <span>{{ $tc("payment_manager.btn_disable") }}?</span>
              </v-tooltip>
            </v-btn>

            <v-btn icon @click="() => { selectedItem = item; dialogConfirmation = true }" v-if="!item.isActive">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <i class="fas fa-times-circle fa-lg" v-on="on"></i>
                </template>
                <span>{{ $tc("payment_manager.btn_enable") }}?</span>
              </v-tooltip>
            </v-btn>
          </template>
        </v-data-table>
        </v-col>
      </v-row>
    </div>
    <!-- Delete Dialog -->
    <v-dialog v-model="dialogDelete" persistent no-click-animation max-width="400px">
      <v-card>
        <v-card-title class="text-left">{{ $tc("payment_manager.disable_title")}}</v-card-title>
        <v-card-text class="text-left">
          <p>{{ $t("payment_manager.confirm_delete_paypal", { CURRENT_YEAR: currentYear } )}}</p>
          <div v-for="(event, index) in events" :key="event.id">
            <span>{{ event.eventName }}<span v-if="index < events.length - 1">,</span></span>
          </div>
          <p class="mt-3">{{ $t("payment_manager.confirm-delete") }}</p>
        </v-card-text>  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="closeDialogDelete">{{ $tc('payment_manager.btn_cancel') }}</v-btn>
          <v-btn color="primary" @click="changeStatus">{{ $tc('payment_manager.btn_disable') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Add/Edit Dialog -->
    <v-dialog v-model="dialog" persistent no-click-animation max-width="400px">
      <v-card>
        <v-card-title>
          {{ isEdit ? $tc("payment_manager.update_payment_method_title") : $tc("payment_manager.add_payment_method_title") }}
        </v-card-title>
        <v-form ref="form" lazy-validation>
        <v-card-text>          
            <v-select
              v-model="paymentAcc.systemPlatformId"
              :items="paymentMethods"
              v-show="!isEdit"
              :label="$tc('payment_manager.select_payment_method')"
              class="mb-2"
              dense
              outlined
              return-object
              @change="changePaymentMethod"
              :rules="paymentAccRules"
              :disabled="isEdit"
            ></v-select>
            <template v-if="isPayPal">
              <v-text-field
                v-model="paymentAcc.paymentName"
                :label="$tc('payment_manager.payment_name')"
                :rules="paymentNameRules"
                dense
                outlined
                class="mb-2"
              ></v-text-field>
              <v-text-field
                v-model="paymentAcc.accountId"
                :label="$tc('payment_manager.payment_email')"
                :rules="paymentEmailRules"
                dense
                outlined
                class="mb-2"
              ></v-text-field>
            </template>    
            <template v-if="isStripe">
              <v-text-field
                v-show="isEdit"
                v-model="paymentAcc.paymentName"
                :label="$tc('payment_manager.payment_name_stripe')"
                :rules="paymentNameRules"
                dense
                outlined
                class="mb-2"
              ></v-text-field>
              <p class="mb-2 text-left">{{ isEdit ? $tc("payment_manager.confirm_edit_stripe") : $tc("payment_manager.confirm_add_stripe") }}</p>
            </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="closeDialog">{{ $tc('payment_manager.btn_cancel') }}</v-btn>
          <v-btn color="primary" :disabled="!paymentAcc.systemPlatformId?.value" @click="savePaypalAccount">{{ isEdit ? $tc('payment_manager.btn_save') : $tc('payment_manager.btn_add') }}</v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
    </v-dialog>
    <v-snackbar location="top" v-model="snack" :color="color_snack">{{ msg_snack }}</v-snackbar>
    <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('payment_manager.confirm-delete')" 
    @cancel="dialogNotification=false;" @agree="changeStatus" type='warning' :acept="$t('payment_manager.btn_disable')" :reject="$t('common.form.cancel')"/>
    <SGSNotificationConfirm v-if="dialogConfirmation" :notificationMessage="$t('payment_manager.confirm-enable')" 
    @cancel="dialogConfirmation=false;" @agree="changeStatus" type='warning' :acept="$t('payment_manager.btn_enable')" :reject="$t('common.form.cancel')"/>
  </v-row>
  
</template>
  
  <script>
  import { apiCalls } from "@/mixins/apiCalls.js";
  import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
  export default {
    name:"PaymentManager",
    components: {SGSNotificationConfirm},
    mixins: [apiCalls],
    data(){
      return{
        items:[],
        paymentMethods:[],
        dialog: false,
        dialogDelete: false,
        valid: true,
        paymentAcc: {
          paymentName: "",
          accountId: "",
          systemPlatformId: {
            value: null,
            text: ""
          }
        },
        isEdit: false,
        events: [],
        userCurrent: null,
        dialogNotification: false,
        selectedItem: null,
        dialogConfirmation: false,
        snack: false,
        color_snack: '',
        msg_snack: ''
      }
    },
    methods:{
      async getUser() {
          const getUserCurrent = await this.api("get", "/api/v1/users/current");
          const getPromoter = await this.api("get", `/api/v1/promoter/promoter-id/${getUserCurrent.message.id}`);
          this.userCurrent = getPromoter;
      },
      changePaymentMethod(){
        this.$refs.form.resetValidation();
        this.paymentAcc.paymentName = "";
        this.paymentAcc.accountId = "";
      },
      async changeStatus(){
        const response = await this.api("put", `/api/v1/promoter/payment-account/${this.selectedItem.id}`);
        if(response.success == 1){
          this.color_snack = "success";
          this.msg_snack = this.$t("payment_manager.msg_update_success");
          this.snack = true;
        }else{
          this.color_snack = "error";
          this.msg_snack = this.$t("payment_manager.msg_error");
          this.snack = true;
        }
        this.getPaymentAccounts();
        this.dialogNotification = false;
        this.dialogDelete = false;
        this.dialogConfirmation = false;
      },
      async getEventsByPaymentAccountId(paymentPromoterAccountId){
        const response = await this.api("get", `/api/v1/promoter/events/${paymentPromoterAccountId}`);
        this.events = response.message;
      },
      async getPaymentMethods(){
        const response = await this.api("get", "/api/v1/promoter/payment-platforms");
        this.paymentMethods = response.message.map(({ id, platformName }) => ({
          value: id,
          text: platformName
        }));
      },
      async getPaymentAccounts(){
        const response = await this.api("get", "/api/v1/promoter/payment-accounts");
        this.items = response.message.map(({ id, paymentName, accountId, platformName, isActive, systemPlatformId, paymentAccountPromoterId }) => ({
          id,
          paymentName,
          accountId,
          platformName,
          isActive,
          systemPlatformId,
          paymentAccountPromoterId
        }));
      },
      editItem(item){
        this.paymentAcc = { ...item }; 
        this.paymentAcc.systemPlatformId = {
          value: item.systemPlatformId,
          text: item.platformName
        };
        this.isEdit = true;
        this.dialog = true;
        
      },
      async deleteItem(item){  
        await this.getEventsByPaymentAccountId(item.id);
        this.selectedItem = item;
        if(this.events.length > 0){
          this.dialogDelete = true;
        }else{          
          this.dialogNotification = true;
        }
      },
      closeDialog(){
        this.dialog = false;
        this.isEdit = false;
        this.$refs.form.reset();
      },
      closeDialogDelete(){
        this.dialogDelete = false;
      },
      async redirectToStripe(){
        const response = await this.api("get", "/api/v1/promoter/stripe-config");
        const clientId = response.message.systemPaymentId;
        const redirectUri = `${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/livelaps/oauth/callback`;
        const stripeState = JSON.stringify({
          promoterId: this.userCurrent,
          toGo: 2
        });
        const stripeAuthUrl = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${clientId}&scope=read_write&redirect_uri=${redirectUri}&state=${stripeState}`;
        window.location.href = stripeAuthUrl;
      },
      async savePaypalAccount(){
        if(this.isStripe && !this.isEdit){
          this.redirectToStripe();
        }else if (this.isPayPal || (this.isStripe && this.isEdit)){
          if (this.$refs.form.validate()) {
            let data = {
              paymentName: this.paymentAcc.paymentName,
              accountId: this.paymentAcc.accountId,
              fkSystemPaymentPlatform: this.paymentAcc.systemPlatformId.value,
              promoterId: this.userCurrent,
              id: this.isEdit ? this.paymentAcc.id : null
            };

            if (this.isEdit) {
              const index = this.items.findIndex(item => item.id === this.paymentAcc.id);
              if (index !== -1) {
                this.items[index] = { ...this.paymentAcc };
              }
            } 

            const response = await this.api("post", "/api/v1/livelaps/payment-account", data);
            if(response.success == 1){
              if(response.message.includes("inserted")){
                this.color_snack = "success";
                this.msg_snack = this.$t("payment_manager.msg_add_success");
              }else if(response.message.includes("updated")){
                this.color_snack = "success";
                this.msg_snack = this.$t("payment_manager.msg_update_success");
              }else if(response.message.includes("duplicated")){                
                this.color_snack = "warning";
                this.msg_snack = this.$t("payment_manager.duplicate-payment-method");
              }
            }else{
              this.color_snack = "error";
              this.msg_snack = this.$t("payment_manager.msg_error");
            }
            this.snack = true;
            this.getPaymentAccounts();           
            this.closeDialog();
          } 
        }
              
      }
    },
    computed:{
      currentYear() {
        return new Date().getFullYear();
      },
      isPayPal() {
        return this.paymentAcc.systemPlatformId?.text?.toLowerCase() === "paypal";
      },
      isStripe() {
        return this.paymentAcc.systemPlatformId?.text?.toLowerCase() === "stripe";
      },
      paymentAccRules: function ()
      {
        return [
          v => !!v || this.$t("payment_manager.payment_method_required")
        ];
      },
      paymentNameRules: function ()
      {
        return [
          v => !!v || this.$t("payment_manager.payment_name_required"),
          v => (v || '').length <= 255 || this.$t("payment_manager.payment_name_max")
        ];
      },
      paymentEmailRules: function ()
      {
        return [
          v => !!v || this.$t("payment_manager.payment_email_required"),
          v => (v || '').length <= 255 || this.$t("payment_manager.payment_email_max"),
          v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || this.$t("payment_manager.payment_email_invalid")
        ];
      },
      headers(){
        return [
          { text: this.$t('payment_manager.name'), sortable: false, value: 'paymentName'},
          { text: this.$t('payment_manager.account_id'), value: 'accountId', sortable: true  },
          { text: this.$t('payment_manager.type'), value: 'platformName', sortable: true  },
          { text: this.$t('payment_manager.enabled'), value: 'isActive', sortable: true  },
          { text: this.$t('payment_manager.action'), value: 'actions', sortable: true  }
        ]
      }
    },
    created: function() {
      this.getUser();
      this.getPaymentMethods();
      this.getPaymentAccounts();
    },
    watch: {
    }
  }
  </script>
  
  <style>
  
  </style>